module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_western_clothing-e05f7293732fc335095a1ae213ac5e23.webp";